var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'active': _vm.isActive, 'bounce': _vm.isBounce, 'alert': _vm.hasNewMessages },attrs:{"id":"chatButton"},on:{"click":_vm.toggleChatWindow}})}
var staticRenderFns = []

export { render, staticRenderFns }